
<div style="padding: 0px;">
  <div class="col-sm-12 m-0 text-center"  style="display: inline-block !important;">
    <button mat-raised-button  color="primary"  type="submit" id="addBtn"
                [disabled]="this.data.stringArr?.length==0"
                (click)="exportExcel()">
        <mat-icon aria-hidden="false" aria-label="Add" >description</mat-icon>
        <span style="margin: 0px;padding: 0px;" >Export to Excel</span>
      </button>
      <button mat-raised-button  color="warn"  type="submit" id="addBtn"
                [disabled]="this.data.stringArr?.length==0"
                (click)="onNoClick()">
        <span style="margin: 0px;padding: 0px;" >Close</span>
      </button>
  </div>
</div>

<div class="container-fluid mt-md-3"  style="max-height: 75vh; overflow-y: auto;">

  <div class="row">
    <div class="col-sm-12 mb-5" >

      <table class="col-sm-12 mat-elevation-z8" id="excel-table">
        <ng-container>
          <tr >
            <th *ngFor="let item of data.stringArr">{{item}}</th>
          </tr>
      </ng-container>
      <ng-container >
        <tr *ngFor="let item of data.unitsArr;">
          <td *ngFor="let stringData of data.stringArr">{{item[stringData]}}</td>
        </tr>
      </ng-container>
      </table>

    </div>




  </div>
</div>



